import { docodeHexResponse } from '../../_common/common.utils';
import businessFundActionTypes from './business-fund.types';

const INITIAL_STATE = {
	addBusinessFundDetailsResponse: null,
	updateBusinessFundDetailsResponse: null,
	getBusinessFundListResponse: null,
	getBusinessFundListArr: [],
	fetchBusinessFundDetailsResponse: null,
	fetchBusinessFundDetailsArr: [],
	deleteBusinessFundDetailsResponse: null,
	fetchAllBusinessFundListResponse: null,
	fetchAllBusinessFundListArr: [],
};

const businessfundReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD BUSINESS FUND DETAILS START *********************** */
		case businessFundActionTypes.ADD_BUSINESS_FUND_DETAILS_SUCCESS:
			return { ...state, addBusinessFundDetailsResponse: action.payload };

		case businessFundActionTypes.ADD_BUSINESS_FUND_DETAILS_FAILURE:
			return { ...state, addBusinessFundDetailsResponse: action.payload };

		case businessFundActionTypes.ADD_BUSINESS_FUND_DETAILS_RESPONSE_CHANGED:
			return { ...state, addBusinessFundDetailsResponse: null };
		/** ***************** ADD BUSINESS FUND DETAILS END *********************** */

		/*************** START UPDATE BUSINESS FUND DETAILS ******************/
		case businessFundActionTypes.UPDATE_BUSINESS_FUND_DETAILS_SUCCESS:
			return { ...state, updateBusinessFundDetailsResponse: action.payload };

		case businessFundActionTypes.UPDATE_BUSINESS_FUND_DETAILS_FAILURE:
			return { ...state, updateBusinessFundDetailsResponse: action.payload };

		case businessFundActionTypes.UPDATE_BUSINESS_FUND_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateBusinessFundDetailsResponse: null };
		/*************** END UPDATE BUSINESS FUND DETAILS ******************/

		/*************** START GET BUSINESS FUND LIST ******************/
		case businessFundActionTypes.GET_BUSINESS_FUND_LIST_SUCCESS:
			return {
				...state,
				getBusinessFundListResponse: action.payload,
				getBusinessFundListArr: docodeHexResponse(action.payload, 'GetBusinessFundListKey'),
			};

		case businessFundActionTypes.GET_BUSINESS_FUND_LIST_FAILURE:
			return { ...state, getBusinessFundListResponse: action.payload };

		case businessFundActionTypes.GET_BUSINESS_FUND_LIST_RESPONSE_CHANGED:
			return { ...state, getBusinessFundListResponse: null };
		/*************** END GET BUSINESS FUND LIST ******************/

		/*************** START FETCH BUSINESS FUND DETAILS ******************/
		case businessFundActionTypes.FETCH_BUSINESS_FUND_DETAILS_SUCCESS:
			return {
				...state,
				fetchBusinessFundDetailsResponse: action.payload,
				fetchBusinessFundDetailsArr: docodeHexResponse(
					action.payload,
					'FetchBusinessFundDetailsKey',
				),
			};

		case businessFundActionTypes.FETCH_BUSINESS_FUND_DETAILS_FAILURE:
			return { ...state, fetchBusinessFundDetailsResponse: action.payload };

		case businessFundActionTypes.FETCH_BUSINESS_FUND_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				fetchBusinessFundDetailsResponse: null,
				fetchBusinessFundDetailsArr: [],
			};
		/*************** START FETCH BUSINESS FUND DETAILS ******************/

		/*************** START DELETE BUSINESS FUND DETAILS ******************/
		case businessFundActionTypes.DELETE_BUSINESS_FUND_DETAILS_SUCCESS:
			return { ...state, deleteBusinessFundDetailsResponse: action.payload };

		case businessFundActionTypes.DELETE_BUSINESS_FUND_DETAILS_FAILURE:
			return { ...state, deleteBusinessFundDetailsResponse: action.payload };

		case businessFundActionTypes.DELETE_BUSINESS_FUND_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteBusinessFundDetailsResponse: null };
		/*************** START DELETE BUSINESS FUND DETAILS ******************/

		/*************** START GET ALL BUSINESS FUNDS ******************/
		case businessFundActionTypes.FETCH_ALL_BUSINESS_FUND_SUCCESS:
			return {
				...state,
				fetchAllBusinessFundListResponse: action.payload,
				fetchAllBusinessFundListArr: docodeHexResponse(
					action.payload,
					'FetchAllBusinessFundsKey',
				),
			};

		case businessFundActionTypes.FETCH_ALL_BUSINESS_FUND_FAILURE:
			return { ...state, fetchAllBusinessFundListResponse: action.payload };

		case businessFundActionTypes.FETCH_ALL_BUSINESS_FUND_RESPONSE_CHANGED:
			return { ...state, fetchAllBusinessFundListResponse: null };
		/*************** END GET ALL BUSINESS FUNDS ******************/

		default:
			return state;
	}
};

export default businessfundReducer;
